export default `vec3 I=p;
  float e=9.0;
  float d=0.0;
  vec2 uv = p.xy / 2.0;
  for(float j=0;j<PI;j+=PI/3.)
    p=I,
    p.x+=j*4.,
    p.y+=sin(p.x*.5),
    p.z+=sin(p.x)*.5,
    e=min(e,(length(p.yz)-length(uv)/4.)*.8);
    d+=e;
  return d;
}`